/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const DictionaryTypeDto = {
    Tag: 'TAG',
    MenuType: 'MENU_TYPE',
    DishDepartment: 'DISH_DEPARTMENT',
    DishType: 'DISH_TYPE',
    DietaryPreference: 'DIETARY_PREFERENCE',
    PackageOfferItem: 'PACKAGE_OFFER_ITEM',
    SupplierType: 'SUPPLIER_TYPE',
    EmergencyContactCategoryType: 'EMERGENCY_CONTACT_CATEGORY_TYPE',
    CarType: 'CAR_TYPE',
    PredefinedOffer: 'PREDEFINED_OFFER',
    EventType: 'EVENT_TYPE',
    CarDeadlineType: 'CAR_DEADLINE_TYPE',
} as const;

export type DictionaryTypeDto = typeof DictionaryTypeDto[keyof typeof DictionaryTypeDto];



